import { Fragment, useRef } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import classNames from 'classnames'
import { EmptyFunction } from '../utils/functions'
import ImageWithBasePath from './ImageWithBasePath'

const ModalHeader = ({
  handleModalClose,
  title,
  headerClassName,
  isDocUploadFlow = false,
  isLocality = false,
  isJobTitle=false,
  id
}) => {
  return (
    <div
      id="modal_header"
      className={
        (isLocality || isJobTitle)
          ? 'flex items-center gap-[16px] border-b-[1px] border-solid border-none border-[#E5E5E5] p-[16px] font-noto-sans '
          : classNames(
              'shadow-md relative flex h-[50px] place-items-center pr-[18px] font-noto-sans',
              isDocUploadFlow ? 'justify-between px-[16px]' : 'place-content-end',
              headerClassName
            )
      }
    >
      <div
        id="modal_title"
        className={
          (isLocality || isJobTitle)
            ? 'flex-[1] text-[20px] font-bold leading-[28px]'
            : classNames(
                isDocUploadFlow
                  ? 'text-[16px]'
                  : 'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform text-base',
                ' font-bold leading-22'
              )
        }
      >
        {id ? id : title}
      </div>
      <div id="modal_close" className="h-fit w-fit cursor-pointer" onClick={handleModalClose}>
        <ImageWithBasePath src={'close'} width={24} height={24} alt="close symbol" />
      </div>
    </div>
  )
}

export function FooterModal({
  isOpen = false,
  handleModalClose = EmptyFunction,
  children,
  title = '',
  isDocUploadFlow = false,
  className = '',
  isHeaderPresent = true,
  headerClassName = '',
  isLocality = false,
  isJobTitle = false,
  id
}) {
  const cancelButtonRef = useRef(null)

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-[99999]"
        initialFocus={cancelButtonRef}
        onClose={handleModalClose}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className={classNames(
              ' fixed inset-0 bg-modalWrapper transition-opacity',
              typeof Android != 'undefined' ? 'bg-opacity-75' : 'bg-opacity-75'
            )}
          />
        </Transition.Child>

        <div className="scrollbarHidden fixed inset-0 z-20 overflow-hidden">
          <div className="md:p-0 flex min-h-full items-end  justify-center text-center md:items-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 md:translate-y-0 md:scale-95"
              enterTo="opacity-100 translate-y-0 md:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 md:scale-100"
              leaveTo="opacity-0 translate-y-4 md:translate-y-0 md:scale-95"
            >
              <Dialog.Panel
                id="modal"
                className={classNames(
                  'md:my-8 shadow-xl relative w-full transform overflow-hidden rounded-t-[16px] bg-[white] text-left md:w-full md:max-w-lg',
                  className
                )}
              >
                {isHeaderPresent && (
                  <ModalHeader
                    {...{
                      handleModalClose,
                      title,
                      headerClassName,
                      isDocUploadFlow,
                      isLocality,
                      isJobTitle,
                      id
                    }}
                  />
                )}
                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
